import * as React from "react";

import classNames from "classnames";

interface DocSliderBarProps extends SliderBarNode, EveryNodeArgs {}

export default function DocSliderBar(props: DocSliderBarProps) {
  const [internalValue, setInternalValue] = React.useState<number>();

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (internalValue) {
        props.currentUser.addState({[props.uid]: {"value": internalValue}});
        setInternalValue(undefined);
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [internalValue]);

  const derivedValue = internalValue || props.value || props.minValue;

  return (
    <div className={classNames("doc-slider-bar", {"inactive": props.inactiveBoolean})}>
      <input
        type="range"
        min={props.minValue}
        max={props.maxValue}
        step={props.step}
        disabled={props.inactiveBoolean}
        value={derivedValue}
        onChange={(e) => setInternalValue(parseInt(e.target.value))}
      />
      {props.showValue ? <h6>{derivedValue}</h6> : ""}
    </div>
  );
}
